import { http } from "../Common/api";

// Every financial calendar subscription call lives here so the endpoints stay
// in one place. `update` is expected to move to a new endpoint shortly, so it
// is deliberately the only thing that knows the update URL and verb.
export const newsEventApi = {
  get: (id) => http.get(`financial-calendar/subscription/${id}`),

  update: (id, body) => http.put(`financial-calendar/subscription/${id}`, body),

  remove: (id) => http.delete(`financial-calendar/subscription/${id}`),

  activate: (id) => http.put(`financial-calendar/subscription/${id}/activate`),

  // Re-subscribing an address is an upsert: 201 with the same id, never a 409.
  create: (listingId, body) =>
    http.post(`financial-calendar/listing/${listingId}/subscribe`, body),

  // NewsEventSubscriptionDto carries listingId but no companyId, and the
  // styles service is keyed by company. This public endpoint bridges the two
  // and also carries the Arabic company name.
  listing: (listingId) => http.get(`listing-public/${listingId}`),
};

// Pulls the field errors out of a 400 VALIDATION_ERROR response body.
export const validationErrorsOf = (error) => {
  const data = error && error.response && error.response.data;
  if (!data || !data.validationErrors) return [];
  return data.validationErrors;
};
